import { getFileExtenction } from "./files";
import { T, TF } from "react-translator-component";

const MAX_ATTACHMENT_SIZE_MB = 30;
const attachmentAllowedExtensions = [".png", ".jpeg", ".jpg", ".webp", ".heic", ".doc", ".docx", ".pdf", ".ppt", ".pptx", ".xlsx", ".xls"];

export const attachmentAcceptedExtension = attachmentAllowedExtensions.join(",");

export const validateAttachment = (file: any): string => {
  if (file.size > MAX_ATTACHMENT_SIZE_MB * 1024 * 1024) {
    return TF(T("error_file_size"), MAX_ATTACHMENT_SIZE_MB, T("post_file"));
  }
  if (
    !attachmentAllowedExtensions.map((ext: string) => ext.replace(/^\./, "")).includes(getFileExtenction(file))
  ) {
    return `${attachmentAllowedExtensions.join(", ")} ${T("error_file_extension")}`;
  }
  return ""
}
